import { render, staticRenderFns } from "./movimiento_NO_producto_ComboGeneracionDocumento.vue?vue&type=template&id=81669d2a&scoped=true"
import script from "./movimiento_NO_producto_ComboGeneracionDocumento.vue?vue&type=script&lang=js"
export * from "./movimiento_NO_producto_ComboGeneracionDocumento.vue?vue&type=script&lang=js"
import style0 from "./movimiento_NO_producto_ComboGeneracionDocumento.vue?vue&type=style&index=0&id=81669d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81669d2a",
  null
  
)

export default component.exports